<template>
 <ul class="px-[10px]">
    <TransactionCard 
      v-for="value in transactions.items" 
      :key="value.id"
      :transaction="value" />
  </ul>
</template>

<script>
import TransactionCard from '@/components/common/TransactionCard.vue';

export default {
  name: 'AllTransactionsList',
  components: {
    TransactionCard,
  },
  props: {
    transactions: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
